import { runSagas } from "@/containers/runSagas";
import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { createReducer } from "./reducers";

const sagaMiddleware = createSagaMiddleware();

export const { run: runSaga } = sagaMiddleware;

export function configureAppStore() {
  const store = configureStore({
    reducer: createReducer(),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        // Dates and Web3Auth objects cross the boundary during development;
        // the check costs more than it catches here.
        serializableCheck: false,
      }).concat(sagaMiddleware),
    devTools: import.meta.env.DEV,
  });
  runSagas();
  return store;
}

export type AppStore = ReturnType<typeof configureAppStore>;
export type AppDispatch = AppStore["dispatch"];
